/**
 *
 * @component 个人中心/我的方案/项目管理/协作项目详情/施工进度计划tab/进度详情抽屉
 *
 **/

import { getConfirmation } from '@/utils/$axios';
import React, { useRef, useState } from 'react';
import {
    AutoComplete,
    Upload,
    Tooltip,
    message,
    Image,
    Input,
    Form,
    Modal,
    Drawer,
    Button,
    Dropdown,
    Checkbox,
    Spin,
    Menu,
    Tabs,
    Row,
    Col,
} from 'antd';
import axios from 'axios';
import { PLAN_STATUS } from '&/utils/baseMacro';
import PlanTreeModal from '../PlanTreeModal';
import PreviewVideo from '&/components/PreviewVideo';
import PreviewAudio from '&/components/PreviewAudio';
import ProjectAdjust from '../ProjectAdjust';
import CheckProgress from '../CheckProgress';
import { createUUID, getImgPreviewUrl } from '&/utils/common.js';
import dayjs from 'dayjs';
import { useHistory, useLocation } from 'react-router-dom';
import {
    queryDetail,
    queryMembers,
    editPlan,
    clearPlans,
    uploadFile,
    operateAdjunct,
    getTemplateTagList,
} from '@/api/personCenter/projectSpace1.4';
import { SYNERGIA_TAB_STATUS } from '&/utils/baseMacro';
import { observer, inject } from 'mobx-react';
import DynamicList from './DynamicList';
import AdditionalRecord from './AdditionalRecord';
import './index.scss';

const { TabPane } = Tabs;
const { NOT_STARTED, UNCONFIRM, UNDERWAY, PENDING, PASSED, FAILED } =
    PLAN_STATUS;

function DetailDrawer(props) {
    const {
        onClose,
        visible,
        planId,
        statusDict = [],
        onRefresh,
        permission,
        currentRole,
    } = props;

    const location = useLocation();
    const his = useHistory();
    const SEARCH = new URLSearchParams(location.search);
    const projectId = SEARCH.get('id');
    const adjunctId = SEARCH.get('adjunctId');
    const detailTab = SEARCH.get('detailTab');
    const isNeedRefresh = useRef(false);

    // 复用的编辑方法
    const submitEdit = async obj => {
        await editPlan({
            planId,
            projectId,
            ...obj,
        })
            .then(() => {
                getDetail();
                //  只有改变计划工期的时候  关闭弹窗后刷新列表
                isNeedRefresh.current = [1, 8].includes(obj.dop);
            })
            .catch(err => {
                if ([2, 10005].includes(err.code)) getDetail();
                if ([10001].includes(err.code)) {
                    onRefresh();
                    onClose();
                }
            });
    };

    const isMount = useRef(true);

    useEffect(() => {
        if (!visible) {
            isNeedRefresh.current && onRefresh();
            if ((SEARCH.get('planId') || detailTab) && !isMount.current) {
                location.search = '?id=' + SEARCH.get('id');
                his.replace(location.search);
            }
            isMount.current = false;
            setIsEditName(false);
            setIsEditProcess(false);
            setIsEditRemark(false);
            return;
        }
        setActiveKey(detailTab || '0');
        getDetail();
        getMembers();
        isNeedRefresh.current = false;
        queryTagList();
    }, [visible]);

    const [reason, setReason] = useState();
    const DEFUALT_DETAIL = {
        joinMember: [],
        adjunctData: [],
    };
    const [res, setRes] = useState(DEFUALT_DETAIL);
    const [planName, setPlanName] = useState('');
    const [loading, setLoading] = useState(false);
    const [duty, setDuty] = useState({
        name: '',
        roleName: '',
    });
    //  获取进度详情
    async function getDetail() {
        try {
            setLoading(true);
            const { data } = await queryDetail({
                planId,
                projectId,
            });
            if (!data.detail) {
                message.error(intl.get('projectSpace.noPlan'));
                onRefresh();
                onClose();
                return;
            }
            setRes(data.detail);
            setPlanName(data.detail.name);
            setIsEditName(false);
            setProcessOptions([]);
            setDuty({
                name: data.detail.dutyName,
                roleName: data.detail.dutyRole,
            });
            let initChecked = [];
            if (data.detail.joinId) {
                initChecked = JSON.parse(data.detail.joinId);
            }
            setCheckedList(initChecked);
            setReason(Object.values(data.reason));
            const files = data.detail.adjunctData.map(e => ({
                url: e.url,
                name: e.describe,
                fileType: e.fileType,
                size: e.size,
                adjunctId: e.id,
                thumbUrl: e.thumbUrl,
                originalUrl: e.originalUrl,
            }));
            if (!isUploding.current) setFileList(files);
            setSelectDrawing(data.detail.planDrawing || []);

            if (!adjunctId) return;
            const previewFile = files.find(e => e.adjunctId === adjunctId);
            previewFile
                ? ATTRS.onPreview(previewFile)
                : message.warning(intl.get('projectSpace.fileDeleted'));
        } catch (error) {
            if (error.message?.[0] === 600) return;
            onRefresh();
            onClose();
        } finally {
            setLoading(false);
        }
    }

    function removePlan() {
        const modal = Modal.confirm({
            content: intl.get('projectSpace.confirmDel'),
            okText: intl.get('base.delete'),
            cancelText: intl.get('base.cancel'),
            centered: true,
            okButtonProps: { loading: false },
            onOk: async () => {
                modal.update({ okButtonProps: { loading: true } });
                try {
                    const { msg } = await clearPlans({
                        projectId,
                        planId: [planId],
                    });
                    isNeedRefresh.current = true;
                    onClose();
                    message.success(msg);
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    }

    const ACCEPT_LIST = [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'image/bmp',
        'application/pdf',
    ];

    const [accept, setAccept] = useState(ACCEPT_LIST.toString(','));
    const [fileList, setFileList] = useState([]); // 用于显示和控制

    const BASE_CONFIG = {
        multiple: true,
        data: file => {
            let type = file.type.includes('image')
                ? 1
                : file.type.includes('pdf')
                ? 3
                : 2;

            return {
                fileName: file.name,
                dap: 2,
                file_size: file.size,
                type,
            };
        },
        customRequest: async ({
            file,
            onSuccess,
            onError,
            data,
            onProgress,
        }) => {
            const uuid = createUUID();
            const SLIECE_SIZE = 8 * 1024 ** 2;
            const len = Math.ceil(file.size / SLIECE_SIZE);
            const paramList = [];
            let sliceTotle = [];
            let loaded = [];
            for (let i = 0; i < len; i++) {
                const blob =
                    i === len - 1
                        ? file.slice(i * SLIECE_SIZE, file.size)
                        : file.slice(i * SLIECE_SIZE, (i + 1) * SLIECE_SIZE);
                paramList.push({
                    ...data,
                    file: blob,
                    blobNum: i + 1,
                    totalBlobNum: len,
                    uuid,
                });
                sliceTotle.push(100 / len);
                loaded.push(0);
            }
            const requestList = paramList.map(e => {
                const formData = new FormData();
                Object.entries(e).forEach(([k, v]) => {
                    formData.append(k, v);
                });
                return formData;
            });

            axios
                .all(
                    requestList.map((e, idx) =>
                        uploadFile(e, evt => {
                            loaded[idx] =
                                sliceTotle[idx] * (evt.loaded / evt.total);
                            onProgress({
                                percent: loaded.reduce(
                                    (prev, next) => prev + next,
                                    0
                                ),
                            });
                        })
                    )
                )
                .then(arr => {
                    const LATEST = arr.find(e => e.code === 0);
                    onSuccess({ ...LATEST.data, fileType: data.type });
                })
                .catch(error => {
                    getConfirmation();
                    onError(error);
                });
        },
        showUploadList: {
            removeIcon: <i className="filled icon-trash icon-delete-file"></i>,
        },
        iconRender() {
            return <i className="outlined icon-Appendix file-icon"></i>;
        },
    };

    const isUploding = useRef(false);
    const ATTRS = {
        ...BASE_CONFIG,
        fileList: fileList,
        accept,
        onRemove(file) {
            if (!file.adjunctId) return;
            setLoading(true);
            return operateAdjunct({
                adjunctId: file.adjunctId,
                div: 2,
                type: 3,
                dop: 1,
            }).finally(() => {
                setLoading(false);
            });
        },
        onPreview: async file => {
            switch (file.fileType) {
                case '1':
                    currentIndex.current = 0;
                    const thumbUrl = await getImgPreviewUrl({
                        adjunctId: file.adjunctId,
                        path: file.url,
                        projectId,
                    });
                    setcurrentImages([{ ...file, id: file.uid, thumbUrl }]);
                    setGroupVisible(true);
                    break;
                case '2':
                    previewVideo(file.originalUrl);
                    break;
                case '3':
                    previewPDF(file.originalUrl);
                    break;
                case '4':
                    previewAudio(file.originalUrl);
                    break;
                default:
                    break;
            }
        },
        onChange: async ({ file, fileList }) => {
            changeFileList(fileList);

            if (file.status === 'uploading') {
                isUploding.current = true;
            }

            //   删除
            if (file.status === 'removed') return;
            // 添加附件
            const newFiles = fileList.filter(e => e.status);
            if (newFiles.every(e => ['done', 'error'].includes(e.status))) {
                let realFiles = newFiles
                    .filter(e => e.status === 'done')
                    .map(e => {
                        const res = {
                            name: e.name || e.response.fileName,
                            url: e.filePath || e.response.filePath,
                            fileType: e.fileType || e.response.fileType,
                            size: e.response.fileSize,
                        };
                        return res;
                    });
                // 中断附件上传的时候不修改附件信息
                !!realFiles.length &&
                    submitEdit({
                        dop: 5,
                        adjunct: realFiles,
                    });
                isUploding.current = false;
            }
        },
        async beforeUpload(file) {
            setAccept(ACCEPT_LIST.toString(','));
            const isInclude = ACCEPT_LIST.includes(file.type);
            if (!isInclude) message.error(intl.get('projectSpace.uploadLimit'));
            return isInclude || Upload.LIST_IGNORE;
        },
    };

    function changeFileList(fileList) {
        setFileList(
            fileList.map(file => {
                if (file.response) {
                    file.url = file.response.fileLink;
                    file.thumbUrl = file.response.fileLink;
                    file.originalUrl = file.response.fileLink;
                }
                return file;
            })
        );
    }

    const [planVisible, setPlanVisible] = useState(false);

    // 关联
    const handleRelevance = evt => {
        evt.stopPropagation();
        setPlanVisible(true);
    };

    const [selectDrawing, setSelectDrawing] = useState([]);

    //  选择关联施工图回调
    const onSelectPlan = (keys, nodes) => {
        const addDawings = nodes.filter(
            e => !selectDrawing.some(el => el.key === e.key)
        );
        const removeDawings = selectDrawing.filter(
            e => !nodes.some(el => el.key === e.key)
        );

        addDawings.length &&
            submitEdit({
                dop: 6,
                drawings: addDawings,
            });
        removeDawings.length &&
            submitEdit({
                dop: 7,
                drawings: removeDawings,
            });
    };

    // 删除施工图
    const deleteDrawing = item => {
        submitEdit({
            dop: 7,
            drawings: [item],
        });
    };

    const targetDrawing = item => {
        his.push({
            pathname: '/user-center/project-space/scheme-detail',
            search: `id=${projectId}&tab=${SYNERGIA_TAB_STATUS.DRAWING}&drawing_id=${item.key}`,
        });
    };

    const [members, setMembers] = useState([]);
    const [checkedList, setCheckedList] = useState([]);
    const [indeterminate, setIndeterminate] = useState(true);
    const [checkAll, setCheckAll] = useState(false);
    const JOIN_LIST = members.filter(e => e.userId !== res.dutyId);

    const onChange = list => {
        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < JOIN_LIST.length);
        setCheckAll(list.length === JOIN_LIST.length);
    };

    const onCheckAllChange = e => {
        setCheckedList(e.target.checked ? JOIN_LIST.map(e => e.userId) : []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
    };

    const [downVisible, setDownVisible] = useState(false);
    const onVisibleChange = (bool = false) => {
        setDownVisible(bool);
    };

    async function getMembers() {
        const { data } = await queryMembers({
            projectId,
        });
        setMembers(data ?? []);
    }

    // 编辑参与者
    const submitJoinMember = () => {
        onVisibleChange();
        submitEdit({
            dop: 3,
            joinId: checkedList,
            planId,
        });
    };

    const toAdd = ({ target }) => {
        if (!target.getAttribute('data-emitter')) return;
        his.push({
            pathname: '/user-center/project-space/scheme-detail',
            search: `id=${projectId}&tab=${SYNERGIA_TAB_STATUS.MEMBERS}`,
        });
    };

    const noData = (
        <div className="no-data" onClick={toAdd}>
            {intl.get('projectSpace.listEmpty', { add: '' })}
            <span data-emitter="add" className="native-link">
                {intl.get('pages.add')}
            </span>
        </div>
    );

    const menu = (
        <div className="dropdown-menu">
            {!!JOIN_LIST.length ? (
                <>
                    <Checkbox.Group
                        style={{ width: '100%' }}
                        onChange={onChange}
                        value={checkedList}>
                        {JOIN_LIST.map(e => (
                            <div key={e.userId} className="dropdown-menu-item">
                                <Checkbox key={e.userId} value={e.userId}>
                                    <p
                                        className="username-box"
                                        title={e.username}>
                                        <span className="username">
                                            {e.username}
                                        </span>
                                        <span className="role-name">
                                            {e.roleName}
                                        </span>
                                    </p>
                                </Checkbox>
                            </div>
                        ))}
                    </Checkbox.Group>
                    <div className="dropdown-menu-item all">
                        <Checkbox
                            indeterminate={indeterminate}
                            onChange={onCheckAllChange}
                            checked={checkAll}>
                            {intl.get('base.all')}
                        </Checkbox>
                        <Button onClick={submitJoinMember}>确定</Button>
                    </div>
                </>
            ) : (
                <>
                    {noData}
                    <div className="dropdown-menu-item close">
                        <Button onClick={onVisibleChange}>
                            {intl.get('base.close')}
                        </Button>
                    </div>
                </>
            )}
        </div>
    );

    // 编辑负责人
    const onSelectDuty = ({ key }) => {
        if (key === 'null') {
            key = null;
        }
        submitEdit({
            dutyId: key,
            dop: 2,
            planId,
        });
    };

    const authorities = members.filter(e => !checkedList?.includes(e.userId));

    const selectMenu = authorities.length ? (
        <Menu onClick={onSelectDuty} className="single-selection">
            {authorities.map(e => {
                return <Menu.Item key={e.userId}>{e.username}</Menu.Item>;
            })}
            <Menu.Item key={null}>{intl.get('base.clear')}</Menu.Item>
        </Menu>
    ) : (
        <div className="no-data-wrap">{noData}</div>
    );

    const mediaSrc = useRef({
        video: '',
        audio: '',
    });
    const [videoVisible, setVideoVisible] = useState(false);
    const closeVideoHandler = () => {
        setVideoVisible(false);
    };

    const previewVideo = src => {
        mediaSrc.current.video = src;
        setVideoVisible(true);
    };

    const [audioVisible, setaudioVisible] = useState(false);
    const previewAudio = src => {
        mediaSrc.current.audio = src;
        setaudioVisible(true);
    };

    const previewPDF = src => {
        const path = src.replace(/^https?:/i, window.location.protocol);
        window.open(window.location.origin + `/preview-pdf?path=${path}`);
    };

    const [adjustVisible, setAdjustVisible] = useState(false);
    const closeAdjustHandler = () => {
        setAdjustVisible(false);
    };

    function showAdjustModal() {
        setAdjustVisible(true);
    }

    const [progressVisible, setProgressVisible] = useState(false);

    const closeProgress = () => {
        setProgressVisible(false);
    };

    function showProgress() {
        setProgressVisible(true);
    }

    const { Item } = Form;

    const statusList = status => {
        switch (status) {
            case UNDERWAY:
            case PENDING:
                return {
                    className: 'underway',
                    icon: 'clock',
                };
            case PASSED:
                return {
                    className: 'finished',
                    icon: 'check-circle',
                };
            case FAILED:
                return {
                    className: 'postpone',
                    icon: 'clock',
                };

            default:
                return {
                    className: 'unstart',
                    icon: 'minus-circle',
                };
        }
    };
    /*const ref = useRef();
 
     const link =
         'https://www.foxithd.com/online/site/pcenter/projectmanage?inviteId=3FO4K4W0Y3FU';*/

    // 两种方式复制到剪切板
    /*const copyLink = async () => {
         const { clipboard } = navigator;
         try {
             if (!clipboard) throw new Error();
             await clipboard.writeText(link);
         } catch {
             ref.current.resizableTextArea.textArea.select();
             document.execCommand('copy');
         } finally {
             message.success(intl.get('decorationDesign.copysuccessful'));
         }
     };*/

    /*const stareContent = (
         <div className="share-step">
             <div className="group-name">链接分享</div>
             <div className="copy-link">
                 <Input.TextArea
                     ref={ref}
                     value={link}
                     autoSize
                     bordered={false}
                     readonly
                 ></Input.TextArea>
                 <Button type="primary" onClick={copyLink}>
                     复制链接
                 </Button>
             </div>
             <div className="group-name">
                 {intl.get('decorationDesign.qrCodeShare')}
             </div>
             <footer className="qrcode">
                 <Image
                     preview={false}
                     className="qrcode-image"
                     src={require('@/assets/img/qrc.png').default}
                 ></Image>
                 {intl.get('decorationDesign.qrCodeShare')}
             </footer>
         </div>
     );*/

    const currentIndex = useRef(0);
    const [groupVisible, setGroupVisible] = useState(false);
    const [currentImages, setcurrentImages] = useState([]);
    const [isClosePreview, setIsClosePreview] = useState(false);

    useEffect(() => {
        if (isClosePreview && SEARCH.get('adjunctId')) {
            const index = location.search.indexOf('adjunctId');
            location.search = location.search.slice(0, index - 1);
            his.replace(location.search);
        }
    }, [isClosePreview]);
    //   是否为项目或者计划创建人
    function isCreator() {
        return currentRole !== -1 && (currentRole === 8 || res.execute === 1);
    }

    // 计算实际工期
    const calcFinishDate = () => {
        if (!res.finishAt || !res.finishEnd) return;
        let day =
            dayjs(res.finishEnd * 1_000).diff(
                dayjs(res.finishAt * 1_000),
                'day'
            ) + 1;
        return intl.get('projectSpace.days', {
            day,
        });
    };

    const [isEditName, setIsEditName] = useState(false);

    const onEditName = async () => {
        if (!isEditName) {
            setPlanName(res.name);
            setIsEditName(true);
            return;
        }
        if (!planName)
            return message.warning(intl.get('projectSpace.planNameEmpty'));
        await submitEdit({
            dop: 8,
            planName: planName,
        });
        setIsEditName(false);
    };

    const onCancelEditName = () => {
        setIsEditName(res.name);
        setIsEditName(false);
    };

    const onNameChange = e => {
        if (e.target.value.length > 30) {
            return;
        }
        setPlanName(e.target.value);
    };

    const [constructionProcess, setConstructionProcess] = useState(undefined);
    const [isEditProcess, setIsEditProcess] = useState(false);
    const [isEditRemark, setIsEditRemark] = useState(false);
    const [remark, setRemark] = useState('');
    const [templateTagList, setTemplateTagList] = useState([]);
    const [processOptions, setProcessOptions] = useState([]);

    useEffect(() => {
        setProcessOptions(templateTagList);
    }, [templateTagList, isEditProcess]);

    const queryTagList = async () => {
        try {
            const sendData = {
                projectId: projectId,
            };
            const res = await getTemplateTagList(sendData);
            const option = res.data.map(item => {
                return { label: item.title, value: item.title };
            });
            setTemplateTagList(option);
        } catch (e) {}
    };
    const onEditProcess = async () => {
        if (!isEditProcess) {
            setConstructionProcess(res.tagName);
            setIsEditProcess(true);
            return;
        }
        // if (!constructionProcess) return message.warning('施工流程不能为空');
        await submitEdit({
            dop: 9,
            tagName: constructionProcess,
        });
        setIsEditProcess(false);
    };

    const onEditRemark = async () => {
        if (!isEditRemark) {
            setRemark(res.remark);
            setIsEditRemark(true);
            return;
        }
        await submitEdit({
            dop: 4,
            remark,
        });
        setIsEditRemark(false);
    };

    function onRemarkChange(e) {
        setRemark(e.target.value);
    }

    function onCancelEditRemark() {
        setIsEditRemark(false);
    }

    const onCancelEditProcess = () => {
        setIsEditProcess(false);
    };
    const onChangeProcess = value => {
        if (value?.length <= 10 || !value) {
            const regProcess = new RegExp(
                "[`~!@#$%^&*()+=|{}':;,\\\\[\\].<>/?！￥…（）—【】‘；：”“’。 ，、？]"
            );
            if (regProcess.test(value)) {
                setConstructionProcess(constructionProcess);
                return;
            }
            setConstructionProcess(value);
        }
    };
    const onSearchProcess = searchText => {
        const filterList = templateTagList.filter(
            item => item.value.indexOf(searchText) !== -1
        );
        setProcessOptions(filterList);
    };

    const [activeKey, setActiveKey] = useState('0');

    const needRefresh = () => {
        isNeedRefresh.current = true;
    };

    const TABS = [
        { name: intl.get('projectSpace.plan'), key: '0' },
        { name: intl.get('projectSpace.additionalRecord'), key: '1' },
        /* { name: '装修待办', key: '2' },
        { name: '巡检', key: '3' }, */
        { name: intl.get('projectSpace.dynamics'), key: '4' },
    ];

    const TAB_CONTENT = [
        <Spin spinning={loading}>
            <Row>
                <Col span={12}>
                    <Item
                        className="edit-item can-edit"
                        label={intl.get('projectSpace.constructionProcess')}>
                        {isEditProcess ? (
                            <AutoComplete
                                allowClear
                                options={processOptions}
                                style={{ width: 200 }}
                                onChange={onChangeProcess}
                                onSearch={onSearchProcess}
                                value={constructionProcess}
                            />
                        ) : (
                            res.tagName ||
                            intl.get('templateSettings.notClassified')
                        )}
                        <span
                            className={[
                                isEditProcess ? 'process-btn' : 'edit-btn',
                                isCreator() ? 'native-link' : 'type--disabled',
                            ].join(' ')}
                            onClick={isCreator() ? onEditProcess : undefined}>
                            {isEditProcess ? (
                                intl.get('retrievePass.finish')
                            ) : (
                                <i className="filled icon-pencil"></i>
                            )}
                        </span>
                        {isEditProcess && (
                            <span
                                className="native-link process-btn"
                                onClick={onCancelEditProcess}>
                                {intl.get('base.cancel')}
                            </span>
                        )}
                    </Item>
                    <Item
                        className={[
                            'edit-item',
                            res.status === PASSED || res.status === FAILED
                                ? 'can-edit'
                                : '',
                        ].join(' ')}
                        label={intl.get('projectSpace.status')}>
                        {res.isDelay === '1' && UNCONFIRM !== res.status ? (
                            <div className="status--postpone">
                                <i
                                    className={`outlined icon-${
                                        statusList(res.status).icon
                                    } icon-status`}
                                />{' '}
                                {intl.get('projectSpace.postponed')}
                            </div>
                        ) : (
                            <div
                                className={`status--${
                                    statusList(res.status).className
                                }`}>
                                <i
                                    className={`outlined icon-${
                                        statusList(res.status).icon
                                    } icon-status`}
                                />{' '}
                                {statusDict[res.status ?? NOT_STARTED]?.name}
                            </div>
                        )}
                        {[PASSED, FAILED].includes(res.status) && (
                            <a
                                className="native-link edit-btn"
                                onClick={showProgress}>
                                {intl.get('projectSpace.viewCheckRemark')}
                            </a>
                        )}
                    </Item>
                    <Item
                        className={[
                            'edit-item',
                            res.status !== PASSED && res.status !== FAILED
                                ? 'can-edit'
                                : '',
                        ].join(' ')}
                        label={intl.get('projectSpace.planLimit')}>
                        {dayjs(res.timeAtDate).format('YYYY-MM-DD')}{' '}
                        {intl.get('base.to')}{' '}
                        {dayjs(res.timeEndDate).format('YYYY-MM-DD')}{' '}
                        {intl.get('projectSpace.days', {
                            day: res.times ?? 0,
                        })}
                        {![PENDING, PASSED, FAILED].includes(res.status) && (
                            <span
                                className={`${
                                    isCreator()
                                        ? 'native-link edit-btn'
                                        : 'edit-btn type--disabled'
                                }`}
                                onClick={
                                    isCreator() ? showAdjustModal : undefined
                                }>
                                <i className="filled icon-pencil"></i>
                            </span>
                        )}
                    </Item>

                    {[UNDERWAY, PENDING, PASSED, FAILED].includes(
                        res.status
                    ) && (
                        <>
                            <Item label={intl.get('projectSpace.realityLimit')}>
                                {res.finishAt &&
                                    dayjs(res.finishAt * 1e3).format(
                                        'YYYY-MM-DD'
                                    )}{' '}
                                {intl.get('base.to')}{' '}
                                {res.finishEnd
                                    ? dayjs(res.finishEnd * 1e3).format(
                                          'YYYY-MM-DD'
                                      )
                                    : '-'}{' '}
                                {calcFinishDate()}
                            </Item>
                        </>
                    )}
                    <Item label={intl.get('projectSpace.creator')}>
                        {res.createName}
                    </Item>
                    <Item
                        className="edit-item can-edit ellipsis-item"
                        label={intl.get('team.principal')}>
                        <span className="user-name" title={duty.name}>
                            {duty.name}
                        </span>
                        <span className="extra-tag">{duty.roleName}</span>
                        <Dropdown
                            overlay={selectMenu}
                            trigger={isCreator() ? ['click'] : []}>
                            <span
                                className={`${
                                    isCreator()
                                        ? 'native-link edit-btn'
                                        : 'edit-btn type--disabled'
                                }`}>
                                <i className="filled icon-pencil"></i>
                            </span>
                        </Dropdown>
                    </Item>

                    <Item
                        className="edit-item can-edit ellipsis-item"
                        label={intl.get('team.participant')}>
                        {res.joinMember?.map((e, idx) => (
                            <React.Fragment key={e.role}>
                                <span className="user-name" title={e.username}>
                                    {e.username}
                                </span>
                                <span className="extra-tag">{e.roleName}</span>
                            </React.Fragment>
                        ))}
                        <Dropdown
                            overlay={menu}
                            trigger={isCreator() ? ['click'] : []}
                            visible={downVisible}
                            onVisibleChange={onVisibleChange}>
                            <span
                                className={`${
                                    isCreator()
                                        ? 'native-link edit-btn'
                                        : 'edit-btn type--disabled'
                                }`}
                                id="change-or">
                                <i className="filled icon-pencil"></i>
                            </span>
                        </Dropdown>
                    </Item>
                </Col>
                <Col span={12}>
                    <Item
                        label={`附件`}
                        className="accessory"
                        labelCol={{ span: 4 }}>
                        <Upload
                            style={{ width: '100%' }}
                            disabled={!isCreator()}
                            onClick={() => setAccept('')}
                            {...ATTRS}>
                            <div className="upload-content">
                                <Tooltip title="仅支持上传png、jpg、jpeg、bmp、pdf格式的文件">
                                    <span
                                        className={`native-link ${
                                            isCreator() ? '' : 'type--disabled'
                                        }`}>
                                        {intl.get('base.accessoryAdd')}
                                    </span>
                                </Tooltip>
                                &nbsp;/&nbsp;
                                <span
                                    className={`native-link ${
                                        isCreator() ? '' : 'type--disabled'
                                    }`}
                                    onClick={
                                        isCreator()
                                            ? handleRelevance
                                            : undefined
                                    }>
                                    {intl.get('projectSpace.drawingsAssociate')}
                                </span>
                            </div>
                        </Upload>
                        {selectDrawing.map(e => (
                            <section key={e.key} className="file-list">
                                <i className="icon-Linkpdf outlined pdf-icon file-icon"></i>
                                <div
                                    className="file-list-content"
                                    title={e.name}
                                    onClick={() => targetDrawing(e)}>
                                    {e.name}
                                </div>
                                {isCreator() && (
                                    <i
                                        onClick={() => deleteDrawing(e)}
                                        className="filled icon-trash delete-icon"></i>
                                )}
                            </section>
                        ))}
                    </Item>
                    <Item
                        label={intl.get('base.remark')}
                        className="edit-item can-edit remark-wrap">
                        {isEditRemark ? (
                            <Input.TextArea
                                allowClear
                                style={{
                                    flex: '1',
                                }}
                                onChange={onRemarkChange}
                                autoSize
                                value={remark}></Input.TextArea>
                        ) : (
                            <span className="remark-text">{res.remark}</span>
                        )}
                        <span
                            className={[
                                isEditRemark ? 'process-btn' : 'edit-btn',
                                isCreator() ? 'native-link' : 'type--disabled',
                            ].join(' ')}
                            onClick={isCreator() ? onEditRemark : undefined}>
                            {isEditRemark ? (
                                intl.get('retrievePass.finish')
                            ) : (
                                <i className="filled icon-pencil"></i>
                            )}
                        </span>
                        {isEditRemark && (
                            <span
                                className="native-link process-btn"
                                onClick={onCancelEditRemark}>
                                {intl.get('base.cancel')}
                            </span>
                        )}
                    </Item>
                    <Item label={intl.get('userCenter.createDate')}>
                        {dayjs(res.createDate).format('YYYY-MM-DD')}
                    </Item>
                </Col>
            </Row>
        </Spin>,
        <AdditionalRecord
            planId={planId}
            perm={permission}
            role={currentRole}
            projectId={projectId}
            needRefresh={needRefresh}
        />,
        <div></div>,
        <div></div>,
        <DynamicList
            planId={planId}
            permission={permission}
            projectId={projectId}
            BASE_CONFIG={BASE_CONFIG}
            previewPDF={previewPDF}
            previewAudio={previewAudio}
            previewVideo={previewVideo}
            setGroupVisible={setGroupVisible}
        />,
    ];

    return (
        <React.Fragment>
            <Drawer
                width="54.6875rem"
                closable={false}
                getContainer=".progress-gantt-wrap"
                visible={visible}
                maskStyle={{ backgroundColor: 'transparent' }}
                title={null}
                bodyStyle={{
                    padding: '0',
                    backgroundColor: '#fff',
                }}
                destroyOnClose
                style={{
                    position: 'absolute',
                    border: '1px solid #E3E7F2',
                }}
                autoFocus
                className="detail-tabs"
                onClose={onClose}>
                <Form className="detail-wrap" labelAlign="left">
                    <div className="drawer-header">
                        {/* <div className="drawer-header-title">施工进度</div> */}
                        <header
                            className={
                                isEditName
                                    ? 'step-name type--edit'
                                    : 'step-name'
                            }>
                            {isEditName ? (
                                <Input.TextArea
                                    allowClear
                                    onChange={onNameChange}
                                    autoSize
                                    value={planName}></Input.TextArea>
                            ) : (
                                <span className="plan-name text-no-wrap">
                                    {res.name}
                                </span>
                            )}
                            <span
                                className={`${
                                    isCreator()
                                        ? 'native-link edit-btn'
                                        : 'edit-btn type--disabled'
                                }`}
                                onClick={isCreator() ? onEditName : undefined}>
                                {isEditName ? (
                                    intl.get('retrievePass.finish')
                                ) : (
                                    <i className="filled icon-pencil"></i>
                                )}
                            </span>
                            {isEditName && (
                                <span
                                    className="native-link edit-btn"
                                    onClick={onCancelEditName}>
                                    {intl.get('base.cancel')}
                                </span>
                            )}
                        </header>
                        {/*<Popover
                         placement="bottomRight"
                         content={stareContent}
                         overlayClassName="progress-share"
                         trigger="click"
                     >
                         <Tooltip placement="right" title="分享给协作人员">
                             <strong className="outlined icon-share2 drawer-header-icon"></strong>
                         </Tooltip>
                     </Popover>*/}

                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item
                                        onClick={removePlan}
                                        disabled={!isCreator()}>
                                        {intl.get('projectSpace.delPlan')}
                                    </Menu.Item>
                                </Menu>
                            }
                            placement="bottomRight"
                            arrow>
                            <i className="filled icon-more-h drawer-header-icon"></i>
                        </Dropdown>

                        <i
                            onClick={onClose}
                            className="drawer-header-icon icon-close filled"
                        />
                    </div>

                    <Tabs
                        activeKey={activeKey}
                        destroyInactiveTabPane
                        onChange={setActiveKey}>
                        {TABS.map(e => (
                            <TabPane tab={e.name} key={e.key}>
                                {TAB_CONTENT[e.key]}
                            </TabPane>
                        ))}
                    </Tabs>
                </Form>
            </Drawer>
            <div style={{ display: 'none' }}>
                <Image.PreviewGroup
                    preview={{
                        visible: groupVisible,
                        current: currentIndex.current,
                        onVisibleChange: (visible, prevVisible) => {
                            setIsClosePreview(!visible);
                            setGroupVisible(visible);
                        },
                    }}>
                    {currentImages.map(el => {
                        return <Image key={el.id} src={el.thumbUrl}></Image>;
                    })}
                </Image.PreviewGroup>
            </div>
            <PreviewVideo
                visible={videoVisible}
                src={mediaSrc.current.video}
                onCancel={closeVideoHandler}
            />

            <PreviewAudio
                visible={audioVisible}
                src={mediaSrc.current.audio}
                onCancel={() => setaudioVisible(false)}
            />

            <ProjectAdjust
                visible={adjustVisible}
                reason={reason}
                initValues={res}
                submitAdjust={submitEdit}
                onCancel={closeAdjustHandler}
            />

            <CheckProgress
                params={{ projectId, planId }}
                visible={progressVisible}
                onCancel={closeProgress}
            />

            <PlanTreeModal
                visible={planVisible}
                setVisible={setPlanVisible}
                onSelected={onSelectPlan}
                initValues={selectDrawing}
                projectId={projectId}
            />
        </React.Fragment>
    );
}

export default inject('appStore')(observer(DetailDrawer));
